export default __webpack_public_path__ + "static/media/chevron_right.a597cd84.svg";